<template>
  <div class="top-contain">
    <!-- <el-scrollbar style="height: 100%"> -->
    <div class="icon_content">
      <!-- 顶部标题 -->
      <div class="title_box">
        <div class="title_item left" style="margin-left:324px">下单关怀</div>
        <div class="title_item content" style="margin-left:318px">订单关怀</div>
        <div class="title_item right" style="margin-left:398px">售后关怀</div>
        <div class="back_div back_div_left" style="left: 148px;top: 11px;"></div>
        <div class="back_div back_div_content" style="left: 502px;top: 11px; width: 449px;"></div>
        <div class="back_div back_div_right" style="right: 143px;top: 11px; width: 520px;"></div>
      </div>
      <div class="icons_box">
        <div class="top_icon">
          <!-- 下单关怀（货到） -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/orderCare/goodsOrderCare')">
            <span v-if="openInfo.remindSellerConfigData['11']" class="isOpen">已开启</span>
            <img v-if="asideName == '下单关怀（货到）'" src="@/assets/new-homeIcon/icon_下单关怀_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_下单关怀_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '下单关怀（货到）' }">下单关怀<br />（货到）</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item second top" style="margin-top: 25px;">
              <!-- <div class="icon-infont"></div> -->
              <div class="icon-infont_content dotted"></div>
              <!-- <div class="icon-infont_opp"></div> -->
            </div>
          </div>
          <div class="link_item" style="" @click="jumpToPage('/orderCare/orderCare/expediting')">
            <span v-if="openInfo.remindSellerConfigData['8']" class="isOpen">已开启</span>
            <img v-if="asideName == '催付提醒'" src="@/assets/new-homeIcon/icon_常规催付_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_常规催付_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '催付提醒' }">催付提醒</div>
          </div>

          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content" style="width: 165px;"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>
          <!-- 二次催付 -->
          <!-- <div class="link_item" style="" @click="jumpToPage('/orderCare/orderCare/twiceExpediting')">
            <span v-if="openInfo.remindSellerConfigData['12']" class="isOpen">已开启</span>
            <img v-if="asideName == '二次催付'" src="@/assets/new-homeIcon/icon_二次催付_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_二次催付_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '二次催付' }">二次催付</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div> -->
          <!-- 付款关怀 -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/payReminder/payReminder')">
            <span v-if="openInfo.remindSellerConfigData['1']" class="isOpen">已开启</span>
            <img v-if="asideName == '付款关怀'" src="@/assets/new-homeIcon/icon_付款关怀_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_付款关怀_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '付款关怀' }">付款关怀</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>
          <!-- 发货提醒 -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/transreMind/sendreMind')">
            <span v-if="openInfo.remindSellerConfigData['2']" class="isOpen">已开启</span>
            <img v-if="asideName == '发货提醒'" src="@/assets/new-homeIcon/icon_发货提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_发货提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '发货提醒' }">发货提醒</div>
            <!-- <img v-if="!venderType" style="padding-top:5px" src="@/assets/images/icon_qt.png" alt="" /> -->
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>
          <div class="link_item" :style="iscan ? '':'cursor:no-drop'" @click="iscan?jumpToPage('/orderCare/transreMind/delivereMind'):''">
            <span v-if="openInfo.remindSellerConfigData['13']&&iscan" class="isOpen">已开启</span>
            <img v-if="asideName == '派件提醒'" src="@/assets/new-homeIcon/icon_派件提醒_s.png" class="link_icon" />
            <img v-else-if="iscan" src="@/assets/new-homeIcon/icon_派件提醒_n.png" class="link_icon" />
            <el-tooltip v-else class="item" effect="dark" content="接口限制，不支持该提醒" placement="top-start">
              <img src="@/assets/new-homeIcon/icon_派件提醒disable.png" class="link_icon" />
            </el-tooltip>
            <div class="link_title" :class="{ select_text: asideName == '派件提醒' }">派件提醒</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div class="link_item" :style="iscan ? '':'cursor:no-drop'" @click="iscan?jumpToPage('/orderCare/transreMind/recvreMind'):''">
            <span v-if="openInfo.remindSellerConfigData['14']&&iscan" class="isOpen">已开启</span>
            <img v-if="asideName == '签收提醒'" src="@/assets/new-homeIcon/icon_签收提醒_s.png" class="link_icon" />
            <img v-else-if="iscan" src="@/assets/new-homeIcon/icon_签收提醒_n.png" class="link_icon" />
            <el-tooltip v-else class="item" effect="dark" content="接口限制，不支持该提醒" placement="top-start">
              <img src="@/assets/new-homeIcon/icon_签收提醒disable.png" class="link_icon" />
            </el-tooltip>
            <div class="link_title" :class="{ select_text: asideName == '签收提醒' }">签收提醒</div>
            <!-- <img v-if="!venderType" style="padding-top:5px" src="@/assets/images/icon_qt.png" alt="" /> -->
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div class="link_item" style="" @click="jumpToPage('/orderCare/moneyBack/moneyBack')">
            <span v-if="openInfo.remindSellerConfigData['5']" class="isOpen">已开启</span>
            <img v-if="asideName == '完成提醒'" src="@/assets/new-homeIcon/icon_完成提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_完成提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '完成提醒' }">完成提醒</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div class="link_item" style="" @click="jumpToPage('/orderCare/comtCare/autoEvaluation')">
            <span v-if="openInfo.popCommentConfigData['1']" class="isOpen">已开启</span>
            <img v-if="asideName == '自动催评'" src="@/assets/new-homeIcon/icon_催评提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_催评提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '自动催评' }">自动催评</div>
          </div>

          <!-- 好感度 pop -->
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div class="link_item" style="" @click="jumpToPage('/orderCare/comtCare/thankEvaluation')">
            <span v-if="openInfo.popCommentConfigData['2']" class="isOpen">已开启</span>
            <img v-if="asideName == '好评感谢'" src="@/assets/new-homeIcon/icon_好评感谢_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_好评感谢_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '好评感谢' }">好评感谢</div>
          </div>
          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <!-- <div class="icon-infont"></div> -->
              <div class="icon-infont_content dotted"></div>
              <!-- <div class="icon-infont_opp"></div> -->
            </div>
          </div>

          <div class="link_item" style="" @click="jumpToPage('/orderCare/comtCare/poorEvaluation')">
            <span v-if="openInfo.popCommentConfigData['3']" class="isOpen">已开启</span>
            <img v-if="asideName == '中差评安抚'" src="@/assets/new-homeIcon/icon_中差评安抚_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_中差评安抚_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '中差评安抚' }">中差评安抚</div>
          </div>

          <div style=" float:left" class="margin">
            <div class="icon-item top" style="margin-top: 25px;">
              <div class="icon-infont"></div>
              <div style="margin-left: 8px;width: 21px;" class="icon-infont_content_ju"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div class="link_item" style="" @click="jumpToPage('/orderCare/refunCare/deny')">
            <span v-if="openInfo.refundRemindConfigData['3']" class="isOpen">已开启</span>
            <img v-if="asideName == '拒绝退款'" src="@/assets/new-homeIcon/icon_拒绝退款_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_拒绝退款_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '拒绝退款' }">拒绝退款</div>
          </div>
        </div>
        <!-- 下半部分 -->
        <div class="bottom_icon">
          <div class="order_care_bottom" style=" height:1px; float:left"></div>
          <div class="link_item" style="" @click="jumpToPage('/orderCare/orderCare/presaleExpediting')">
            <div class="top" style="margin-left: 24px; margin-bottom: 10px">
              <div class="icon-infont3"></div>
              <div class="icon-infont4" style="float:left"></div>
              <div class="icon-infont4_opp" style="float:left"></div>
            </div>
            <span v-if="openInfo.remindSellerConfigData['24']" class="isOpen bottom_item">已开启</span>
            <img v-if="asideName == '预售尾款催付'" src="@/assets/new-homeIcon/icon_预售尾款催付_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_预售尾款催付_n.png" class="link_icon" />
            <div class="link_title" style="width:80px;position:absolute;left:-17px" :class="{ select_text: asideName == '预售尾款催付' }">
              预售尾款催付
            </div>
          </div>
          <div class="order_care_bottom_cancelMind" style=" height:1px; float:left"></div>
          <div class="link_item" style="" @click="jumpToPage('/orderCare/transreMind/cancelMind')">
            <div class="top" style="margin-left: 24px; margin-bottom: 10px">
              <div class="icon-infont3"></div>
              <div class="icon-infont4" style="float:left"></div>
              <div class="icon-infont4_opp" style="float:left"></div>
            </div>
            <span v-if="openInfo.remindSellerConfigData['6']" class="isOpen bottom_item">已开启</span>
            <img v-if="asideName == '取消提醒'" src="@/assets/new-homeIcon/icon_取消提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_取消提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '取消提醒' }">取消提醒</div>
          </div>
          <div class="order_care_bottom_delayMind" style=" height:1px; float:left"></div>

          <!-- 迟发提醒   自营 -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/transreMind/delayMind')">
            <div class="top" style="margin-left: 24px; margin-bottom: 10px;margin-right: 5px;float: left;">
              <div class="icon-infont3" style="height:94px"></div>
              <div class="icon-infont"></div>
              <div style="width:44px" class="icon-infont_content"></div>
              <div style="top:108px" class="icon-infont_opp"></div>
            </div>
            <span v-if="openInfo.remindSellerConfigData['3']" class="isOpen bottom_item">已开启</span>
            <div style="float: left;margin-top: 74px;">
              <img v-if="asideName == '迟发提醒'" src="@/assets/new-homeIcon/icon_迟发提醒_s.png" class="link_icon" />
              <img v-else src="@/assets/new-homeIcon/icon_迟发提醒_n.png" class="link_icon" />
              <div class="link_title" :class="{ select_text: asideName == '迟发提醒' }">迟发提醒</div>
              <!-- <img v-if="!venderType" style="padding:5px 0" src="@/assets/images/icon_qt.png" alt="" /> -->
            </div>
          </div>

          <div class="order_care_bottom_delayMind apply" style="width:219px; height:1px; float:left;"></div>

          <!-- 自营 -->
          <div class="link_item" style="" @click="jumpToPage('/orderCare/refunCare/apply')">
            <div class="top" style="margin-left: 24px; margin-bottom: 10px; margin-right: 5px;float: left;">
              <div class="icon-infont3" style="height:94px"></div>
              <div class="icon-infont"></div>
              <div style="width:145px" class="icon-infont_content"></div>
              <div style="top:108px" class="icon-infont_opp"></div>
            </div>
            <span v-if="openInfo.refundRemindConfigData['1']" class="isOpen bottom_item">已开启</span>
            <div style="float: left;margin-top: 74px;">
              <img v-if="asideName == '申请退款'" src="@/assets/new-homeIcon/icon_申请退款_s.png" class="link_icon" />
              <img v-else src="@/assets/new-homeIcon/icon_申请退款_n.png" class="link_icon" />
              <div class="link_title" :class="{ select_text: asideName == '申请退款' }">申请退款</div>
            </div>
          </div>
          <div style=" float:left;margin-top:49px ;position: relative;" class="margin">
            <!-- <div class="icon-infont_top" style="position:absolute;left:241px; top:-57px"></div> -->
            <div class="icon-infont3_long" style="height:70px; margin-top:8px; position:absolute;left:245px; top:-72px"></div>

            <div style="width:221px; position:absolute; left:10px; margin-left: 17px;" class="icon-infont_content_long"></div>
            <div class="icon-infont3 long_top" style=" margin-top:5px;margin-left: 26px; "></div>
            <div class="icon-item top" style="">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>
          <div class="link_item" style="margin-top:75px" @click="jumpToPage('/orderCare/refunCare/agree')">
            <span v-if="openInfo.refundRemindConfigData['2']" class="isOpen ">已开启</span>
            <img v-if="asideName == '同意退款'" src="@/assets/new-homeIcon/icon_同意退款_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_同意退款_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '同意退款' }">同意退款</div>
          </div>
          <div style=" float:left;margin-top:75px" class="margin">
            <div class="icon-item top" style="margin-top: 24px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>
          <div class="link_item" style="margin-top:75px" @click="jumpToPage('/orderCare/transreMind/goodsBackMind')">
            <span v-if="openInfo.remindSellerConfigData['7']" class="isOpen ">已开启</span>
            <img v-if="asideName == '退货提醒'" src="@/assets/new-homeIcon/icon_退货提醒_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_退货提醒_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '退货提醒' }">退货提醒</div>
          </div>
          <div style=" float:left;margin-top:75px" class="margin">
            <div class="icon-item top" style="margin-top: 24px;">
              <div class="icon-infont"></div>
              <div class="icon-infont_content"></div>
              <div class="icon-infont_opp"></div>
            </div>
          </div>

          <div class="link_item" style="margin-top:75px" @click="jumpToPage('/orderCare/refunCare/suces')">
            <span v-if="openInfo.refundRemindConfigData['4']" class="isOpen ">已开启</span>
            <img v-if="asideName == '退款成功'" src="@/assets/new-homeIcon/icon_退款成功_s.png" class="link_icon" />
            <img v-else src="@/assets/new-homeIcon/icon_退款成功_n.png" class="link_icon" />
            <div class="link_title" :class="{ select_text: asideName == '退款成功' }">退款成功</div>
          </div>
        </div>
      </div>
    </div>
    <!-- </el-scrollbar> -->
  </div>
</template>

<script>
export default {
  props: {
    asideName: {
      type: String,
      default: "",
    },
    openInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      selectIndex: "",
      //   routerPath1: false,
      // 1.11 fcs禁用派件提醒和签收提醒
      iscan: false,
      //   routerPath2: false,
    };
  },
  mounted() {
    if(this.$store.getters.loginUserInfo.shopType == 2){
      this.iscan = false
    }else{
      this.iscan = true
    }
    // this.bus.$on("topActive", (obj) => {
    //   obj.item.children.forEach((ele) => {
    //     if (ele.tittle == "评价关怀") {
    //       ele.children.forEach((i) => {
    //         if (i.tittle == "好评感谢（自营）") {
    //           this.routerPath1 = true;
    //         }
    //         if (i.tittle == "中差评安抚（自营）") {
    //           this.routerPath2 = true;
    //         }
    //       });
    //     }
    //   });
    // });
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },
  methods: {
    // 点击图标，路由跳转
    jumpToPage(_val) {
      this.selectIndex = 1;
      this.$router.push({ path: _val });
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 1980px) {
  .title_box {
    .back_div_right {
      width: 512px !important;
      left: 964px !important;
    }
  }
}
@media only screen and (max-width: 1830px) {
  .title_box {
    .back_div_right {
      width: 430px !important;
      left: 964px !important;
    }
  }
}
@media only screen and (max-width: 1730px) {
  .title_box {
    .left {
      margin-left: 184px !important;
    }
    .back_div_left {
      width: 326px !important;
      left: 62px !important;
    }
    .back_div_content {
      width: 400px !important;
      left: 400px !important;
    }
    .back_div_right {
      width: 540px !important;
      left: 810px !important;
    }
  }
}

@media only screen and (max-width: 1600px) {
  .icon-infont_content {
    width: 42px !important;
  }
  .icon-infont_content_long {
    width: 280px !important;
  }
  .icon-infont3_long {
    left: 306px !important;
  }
  .bottom_icon {
    left: -52px;
  }

  .order_care_bottom_cancelMind {
    width: 51px !important;
  }
  .order_care_bottom_delayMind {
    width: 265px;
  }
  .apply {
    width: 186px !important;
  }
  .title_box {
    .left {
      margin-left: 184px !important;
    }
    .back_div_left {
      width: 360px !important;
      left: 62px !important;
    }
    .back_div_content {
      width: 310px !important;
      left: 437px !important;
    }
    .back_div_right {
      width: 490px !important;
      left: 764px !important;
    }
  }
}
@media only screen and (max-width: 1480px) {
  .icon-infont_content {
    width: 33px !important;
  }
  .long_top {
    margin-left: 10px !important;
  }
  .icon-infont_content_long {
    width: 272px !important;
    left: -7px !important;
  }
  .icon-infont3_long {
    left: 281px !important;
  }
  .bottom_icon {
    left: -65px;
  }
  .order_care_bottom {
    width: 179px !important;
  }
  .order_care_bottom_cancelMind {
    width: 40px !important;
  }

  .apply {
    width: 159px !important;
  }
  .top-contain .margin .long_top {
    height: 42px;
    margin-bottom: 4px;
  }
  .title_box {
    .left {
      margin-left: 136px !important;
    }
    .content {
      margin-left: 250px !important;
    }
    .right {
      margin-left: 360px !important;
    }
    .back_div_left {
      width: 277px !important;
      left: 24px !important;
    }
    .back_div_content {
      width: 370px !important;
      left: 310px !important;
    }
    .back_div_right {
      width: 450px !important;
      left: 695px !important;
    }
  }
}
@media only screen and (max-width: 1411px) {
  .icon-infont_content {
    width: 25px !important;
    //    margin-left: 9px;
  }
  .long_top {
    margin-left: 10px !important;
  }
  .icon-infont_content_long {
    width: 239px !important;
    left: -7px !important;
  }
  .icon-infont3_long {
    left: 247px !important;
  }

  .bottom_icon {
    left: -67px;
  }
  .order_care_bottom {
    width: 179px !important;
  }
  .order_care_bottom_cancelMind {
    width: 40px !important;
  }
  .order_care_bottom_delayMind {
    width: 30px !important;
  }
  .apply {
    width: 176px !important;
  }
  .top-contain .margin .long_top {
    height: 42px;
    margin-bottom: 4px;
  }
  .title_box {
    .left {
      margin-left: 136px !important;
    }
    .content {
      margin-left: 250px !important;
    }
    .right {
      margin-left: 260px !important;
    }
    .back_div_left {
      width: 277px !important;
      left: 20px !important;
    }
    .back_div_content {
      width: 340px !important;
      left: 306px !important;
    }
    .back_div_right {
      width: 410px !important;
      left: 660px !important;
    }
  }
}
@media only screen and (max-width: 1350px) {
  .icon-infont_content {
    width: 23px !important;
  }
  .icon-infont_content_ju {
    margin-left: 5px !important;
    width: 14px !important;
  }
  .icon-infont_content_long {
    width: 248px !important;
    left: -7px !important;
  }
  .icon-infont3_long {
    left: 257px !important;
  }

  .bottom_icon {
    left: -73px;
  }
  .order_care_bottom {
    width: 179px !important;
  }
  .order_care_bottom_cancelMind {
    width: 40px !important;
  }
  .order_care_bottom_delayMind {
    width: 30px !important;
  }
  .apply {
    width: 150px !important;
  }
  .top-contain .margin .long_top {
    height: 42px;
    margin-bottom: 4px;
  }
  .title_box {
    .left {
      margin-left: 112px !important;
    }
    .content {
      margin-left: 230px !important;
    }
    .right {
      margin-left: 260px !important;
    }
    .back_div_left {
      width: 268px !important;
      left: 1px !important;
    }
    .back_div_content {
      width: 315px !important;
      left: 280px !important;
    }
    .back_div_right {
      width: 388px !important;
      left: 605px !important;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .bottom_icon {
    left: -71px !important;
  }
  .long_top {
    margin-left: 10px !important;
    // height: 45px;
    // margin-bottom: 0px;
  }
  .icon-infont_content_ju {
    margin-left: 19px !important;
  }
  .icon-infont_content_long {
    width: 253px !important;
    left: -7px !important;
  }
  .icon-infont3_long {
    left: 262px !important;
  }
  .top-contain .margin .long_top {
    height: 42px;
    margin-bottom: 4px;
  }
}

.top-contain {
  padding: 10px 34px 15px;
  position: relative;
  .title_box {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    .title_item {
      min-width: 75px;
      background: #fff;
      z-index: 2;
      color: #999999;
      padding: 2px 8px;
      border: 1px solid#F3F3F3FF;
      height: 24px;
      box-sizing: border-box;
      line-height: 19px;
    }
    .back_div {
      position: absolute;
      width: 342px;
      height: 7px;
      // border-top: 2px ;
      // background: #000;
      border-style: solid;

      border-width: 1px 1px 0;
      // border: 2px solid purple;
      border-color: #eee;
    }
  }
  .icons_box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .top_icon {
    // overflow: hidden;
  }
  .bottom_icon {
    // overflow: hidden;
    position: relative;
    top: -48px;
    .order_care_bottom {
      width: 163px;
    }
    .order_care_bottom_cancelMind {
      width: 63px;
    }
    .order_care_bottom_delayMind {
      width: 63px;
    }
  }
  .link_item {
    float: left;
    position: relative;
    cursor: pointer;
    .link_icon {
      width: 50px;
      height: 60px;
      vertical-align: middle;
    }
    .link_title {
      font-size: 12px;
      // font-family:PingFang SC;
      font-weight: 500;
      line-height: 17px;
      color: #999;
      opacity: 1;
    }
    .select_text {
      color: #333;
    }
    .isOpen {
      position: absolute;
      z-index: 5;
      top: 0px;
      right: -23px;
      color: #fff;
      padding: 4px 6px;
      background: rgba(255, 151, 74, 1);
      box-shadow: 0px 2px 4px rgba(255, 151, 74, 0.5);
      opacity: 1;
      border-radius: 43px;
      padding: 2px 5px;
      font-size: 12px;
    }
    .bottom_item {
      top: 74px;
    }
  }
  .margin {
    margin-left: 5px;
    margin-right: 5px;
    // position: absolute;
    // left: 50px;
    // top: 0px
  }
  .icon-item {
    float: left;
  }
  .second {
  }
  .top {
    position: relative;
  }
  .icon-infont_content {
    margin-top: 4px;
    border-style: solid;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-color: #eeeeee;
    width: 52px;
  }
  .icon-infont_content_ju {
    margin-top: 4px;
    border-style: solid;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-color: #eeeeee;
    width: 52px;
  }
  .icon-infont_content_long {
    margin-top: 4px;
    border-style: solid;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-color: #eeeeee;
    width: 52px;
  }
  .dotted {
    border-style: dashed !important;
  }
  .icon-infont {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(45deg);
    float: right;
  }
  .icon-infont_top {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(-45deg);
    float: right;
  }
  .icon-infont3 {
    margin-top: 10px;
    height: 60px;
    width: 0;
    /*float: left;*/
    border: 1px solid rgba(230, 230, 230, 1);
    margin-bottom: -4px;
  }
  .long_top {
    height: 35px;
    margin-bottom: 11px;
  }
  .icon-infont3_long {
    margin-top: 10px;
    height: 60px;
    width: 0;
    /*float: left;*/
    border: 1px solid rgba(230, 230, 230, 1);
    margin-bottom: -4px;
  }
  .icon-infont4 {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(135deg);
    transform: rotate(135deg);
    float: right;
  }
  .icon-infont4_opp {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(135deg);
    transform: rotate(-135deg);
    position: absolute;
    left: -6px;
  }
  .icon-infont_left {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(-45deg);
    float: right;
  }
  .icon-infont_opp {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(-45deg);
    float: right;
    position: absolute;
    right: 0px;
    top: 8px;
  }
  .icon-infont_opp_top {
    width: 9px;
    border: 1px solid rgba(230, 230, 230, 1);
    // @include rotate(45deg);
    transform: rotate(45deg);
    float: right;
    position: absolute;
    right: 0px;
    top: 8px;
  }
  .icon_content {
    position: relative;
    height: 265px;
    text-align: center;
    margin-top: 10px;
    // margin-bottom: 10px;
    // display: -webkit-box;
  }
  .modules_title {
    font-size: 14px;
    height: 20px;
    color: #333;
    font-weight: bold;
    line-height: 20px;
  }
  .order_care_top {
    overflow: hidden;
  }
}
</style>
